// src/components/ProductCard.js
import React from 'react';
import { Link } from 'react-router-dom';


const ProductCard = ({ id, image, title, description, price }) => {
  return (
    <Link to={`/product/${id}`} className="max-w-md rounded overflow-hidden m-4 flex flex-col items-center">
      <div className="h-96 flex items-center justify-center">
        <img className="h-full object-contain" src={image} alt={title} loading="lazy" />
      </div>
      <div className="px-6 py-4 text-center">
        <div className="font-bold text-xl mb-2">{title}</div>
        <p className="text-gray-700 text-base font-thin">Au coing du ventoux</p>
      </div>
      <div className="px-6  pb-2 text-center">
        <span className="text-gray-900 font-bold text-xl">{price.toFixed(2)} €</span>
      </div>
    </Link>
  );
};

export default ProductCard;
